import React, { useEffect, useState } from "react";
import { TrashMini } from "../../assets/SvgIcons";
import axiosInstance from "../../redux/helpers/axios";
import { useNavigate } from "react-router-dom";

const listingdata = [
  // {
  //   image_url:
  //     "https://cdn2.chrono24.com/images/products/25600-25799/25731_s500_Blue.jpg",
  //   name: "Rolex Submariner",
  //   status: "Active",
  //   description: "Your listing is almost complete",
  //   price: "Price on request",
  //   actions: {
  //     delete_draft: "Delete draft",
  //     finalize_button: "Finalize now",
  //   },
  // },
  // {
  //   image_url:
  //     "https://cdn2.chrono24.com/images/products/25600-25799/25731_s500_Blue.jpg",
  //   name: "Omega Speedmaster",
  //   status: "Pending",
  //   description: "Your listing is awaiting approval",
  //   price: "$4,500",
  //   actions: {
  //     delete_draft: "Delete draft",
  //     finalize_button: "Finalize now",
  //   },
  // },
  // {
  //   image_url:
  //     "https://cdn2.chrono24.com/images/products/25600-25799/25731_s500_Blue.jpg",
  //   name: "Tag Heuer Carrera",
  //   status: "Draft",
  //   description: "Your draft is ready to be finalized",
  //   price: "Price on request",
  //   actions: {
  //     delete_draft: "Delete draft",
  //     finalize_button: "Finalize now",
  //   },
  // },
];

const MyInventory = () => {
  const draft = JSON.parse(localStorage.getItem("draft")) || [];

  const [listings, setListings] = useState([]);

  useEffect(() => {
    axiosInstance.get(`/private/listing/get-by-dealer`).then((res) => {
      setListings([...draft, ...res?.data?.listings]);
    });
  }, []);

  return (
    <div className=" w-full lg:p-4 md:p-4 sm:p-0">
      <h1 className="lg:text-4xl md:text-2xl sm:text-xl mb-8">My Inventory</h1>

      <div className="border-b border-b-secondary border-dashed mb-8">
        <p className="text-xl border-b-2 border-b-secondary mb-[-1.5px] pb-2 px-6 w-fit">
          Listings
        </p>
      </div>

      {/* <div className="grid xl:grid-cols-2 lg:grid-cols-1 md:grid-cols-1 sm:grid-cols-1 gap-4">
        {draft.length > 0 ? (
          draft?.map((item, index) => {
            return <ListingCard item={item} key={index} />;
          })
        ) : (
          <h1 className="lg:text-4xl md:text-2xl sm:text-xl mb-8">
            No Listing Available
          </h1>
        )}
      </div> */}
      <div className="grid xl:grid-cols-2 lg:grid-cols-1 md:grid-cols-1 sm:grid-cols-1 gap-4">
        {listings.length > 0 ? (
          listings?.map((item, index) => {
            return <ListingCard item={item} key={index} />;
          })
        ) : (
          <h1 className="lg:text-4xl md:text-2xl sm:text-xl mb-8">
            No Listing Available
          </h1>
        )}
      </div>
    </div>
  );
};

export default MyInventory;

const ListingCard = ({ item }) => {
  const navigate = useNavigate();
  return (
    <div className="p-4 lg:flex md:flex sm:block gap-4 border">
      {item?.gallery?.length > 0 ? (
        <img
          src={item?.gallery[0]}
          alt=""
          height={240}
          width={240}
          className="rounded-lg border"
        />
      ) : (
        <img
          src="https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg"
          alt=""
          height={240}
          width={240}
          className="rounded-lg border"
        />
      )}

      {/* <img
        src="https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg"
        alt=""
        height={120}
        width={120}
        className="border rounded-lg h-[120px] w-[120px]"
      /> */}

      <div className="w-full">
        <div className="border-b border-b-secondary border-dashed pb-2 flex justify-between">
          <p className="text-[18px]">{item?.model}</p>
          <p className="text-[10px] rounded-lg bg-black text-white px-1 flex justify-center items-center">
            {item?.status ? item?.status?.toUpperCase() : "DRAFT"}
          </p>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div className="py-4">
            {/* <p className="text-[12px] mb-4">{item?.description}</p> */}
            <p className="text-[18px]">
              {item?.pricing?.dealerCurrency} {item?.pricing?.dealerPrice}
            </p>
          </div>
          {item?.status !== "DRAFT" && item?.status !== undefined ? (
            <div className="py-4">
              <button
                onClick={() =>
                  navigate(`/watch?id=${item?.listingId}`, { state: item })
                }
                className="rounded bg-secondary text-white py-2.5 w-full"
              >
                {" "}
                View
              </button>
            </div>
          ) : (
            <div className="py-4">
              <div className="flex gap-2 items-center mb-8">
                {TrashMini} <p className="underline">Delete draft</p>{" "}
              </div>

              <button className="rounded bg-secondary text-white py-2.5 w-full">
                {" "}
                Finalize now
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
